import type { IErrorInfo } from '../errors';
import { errorInfoSchema } from '../errors';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const ERROR = 'VOICE_TO_TEXT/ERROR';

export const errorActionSchema = objectSchemaOf<IErrorAction>({
  type: Joi.string().required().valid(ERROR),
  payload: objectSchemaOf<IErrorAction['payload']>({
    conversationId: Joi.string().required(),
    engine: Joi.string().optional(),
    error: errorInfoSchema.required(),
  }),
});

export interface IErrorAction {
  type: typeof ERROR;
  payload: {
    conversationId: string;
    engine?: string;
    error: IErrorInfo;
  };
}

export const error = actionCreator({
  type: ERROR,
  schema: errorActionSchema,
});
